import isEmpty from 'lodash/isEmpty';
import { MerchantDetails } from '@repo/api/endpoints/merchant';

export const isMerchantContactDataEmpty = (merchantDetails?: MerchantDetails) => {
  return isEmpty(merchantDetails?.email) || isEmpty(merchantDetails?.phone);
};
